export function computeNcrmRecordMainLgCols({
  hasLeftSlot,
  hasRightSlot,
  mainLgColsBoth = 6,
  mainLgColsSingleSide = 9,
}) {
  if (hasLeftSlot && hasRightSlot) {
    return mainLgColsBoth;
  }
  if (hasLeftSlot || hasRightSlot) {
    return mainLgColsSingleSide;
  }
  return 12;
}

export function normalizeNcrmHeaderChips(chips) {
  return (chips || [])
    .filter((chip) => chip && String(chip.text || "").trim())
    .map((chip) => ({
      text: String(chip.text).trim(),
      color: chip.color || "",
      icon: chip.icon || "",
      variant: chip.variant || "",
    }));
}

export function normalizeNcrmHeaderKpis(kpis) {
  return (kpis || [])
    .filter((kpi) => kpi && String(kpi.label || "").trim())
    .map((kpi, index) => ({
      key: String(kpi.key || `kpi-${index}`).trim(),
      label: String(kpi.label).trim(),
      value: String(kpi.value ?? "").trim(),
      icon: kpi.icon || "",
    }));
}
